import React from 'react';

import { Link } from '~/lib/react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import { Accordion, AccordionDetails, AccordionSummary, Box, IconButton, Typography } from '@mui/material';

import MarkdownPreview from '~/components/Common/MarkdownPreview';

import mergeRoomPolicyNames from '../../../utils/mergeRoomPolicyNames';

type Props = {
  offer: {
    result: App.Offer;
  };
  propertyData: any;
};

export default function RoomPolicyPane({ offer, propertyData }: Props) {
  const roomPolicyDetails = mergeRoomPolicyNames(offer.result.packages, propertyData);

  return (
    <span>
      <h1 className="page-header">
        Room Policy
        <Link to={'/edit-offers/' + offer.result.id_salesforce_external + '/room-policies'}>
          <IconButton aria-label="Edit">
            <ModeEditTwoToneIcon fontSize="large" />
          </IconButton>
        </Link>
      </h1>
      <Box>
        {roomPolicyDetails.map((roomPolicy, index) => (
          <Accordion key={`${roomPolicy.id}-${index}`}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="room-policy-content"
              id={`${roomPolicy.id}-${index}`}
            >
              <Typography sx={{ textTransform: 'uppercase', display: 'inline', fontSize: 18, fontWeight: 300 }}>
                {roomPolicy.room_type_name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ borderTop: '1px solid rgba(0, 0, 0, .125)', padding: 2 }}>
              <MarkdownPreview content={roomPolicy.description} />
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </span>
  );
}
